import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

if (environment.production) enableProdMode();

if (!environment.production) Sentry.init({ dsn: environment.sentryDsn, integrations: [] });

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error('Error cargando el módulo principal del proyecto'));
